import React, { useState } from 'react'
import { LeftOutlined } from "@ant-design/icons";
import { Select, Checkbox, Switch } from "antd";
import firebase from 'firebase'
import { Link } from 'react-router-dom'
const EditUser = ({ dataAdmin1, optimiser1, simulator1, ground1, crew1, aircraft1, managerr1,
    Active1, ActiveUserss, setoptimiser1, Active, togless,
    setdataAdmin1, setActive1, setmanagerr1, setsimulator1, setCrew1,
    setGround1, setAircraft1, getuserss, closeForm, clientss, setdropdown2, dropdown2,
    ActiveUserssCrews, ActiveUserssGroundss, ActiveUsersssimulatorss, ActiveUserssaircraft, ActiveUserssmanagerss,
    ActiveUserssdataAdminss, ActiveUserssoptimiser, dataAdmin_actives, crew_actives, aircraft_actives, ground_activs, manager_actives, optimiser_actives,
    simulator_actives,users_actives,userregister
}) => {
    const [search, setsearch] = useState('')

    function onChangeHandler(e, v) {
        if (v === 'active') {
            setActive1(e.target.checked)
        } else if (v === 'Crew') {
            setCrew1(e.target.checked)
        } else if (v === 'Ground') {
            setGround1(e.target.checked)
        } else if (v === 'Simulator') {
            setsimulator1(e.target.checked)
        } else if (v === 'Aircraft') {
            setAircraft1(e.target.checked)
        } else if (v === 'Manager') {
            setmanagerr1(e.target.checked)
        } else if (v === 'Optimiser') {
            setoptimiser1(e.target.checked)
        } else if (v === 'DataAdmin') {
            setdataAdmin1(e.target.checked)
        }
    }
    const Option = Select.Option;
    return (
        <div>
            <div className="category-title">
                <span className="client-back" onClick={() => closeForm()}>
                    {<LeftOutlined />} USERS
            </span>
            Manage Users
          </div>
            <div className="table-body-container">
                <div className="table-body-header">All Users</div>
                <div className="client-list-divider"></div>
                <div className="table-container">
                    <div className="table-header-container">
                        <div className="display-record">
                            <Select value={dropdown2 ? dropdown2 : "Select Client"} onChange={e => setdropdown2(e)}>
                                {clientss?.aatmsv4_clients?.map((el, i) => (
                                    <Option key={i} value={[el.clientname, el.clientsid, el.department]}>{el.clientname}</Option>
                                ))}
                            </Select>
                        </div>
                        <div className="active-switch">
                            <span>Active</span>
                            <Switch onClick={togless} defaultChecked />
                        </div>
                        <div className="search-bar">
                            <span>Search</span>
                            <input type="text" value={search} onChange={(e) => setsearch(e.target.value)} />
                        </div>
                    </div>
                    {dropdown2 !== "" ? (getuserss?.aatmsv4_users?.map((data, index) => {
                        if (data.email.toLowerCase().includes(search.toLowerCase())) {
                            return (
                                <div className="table-row-container" key={index}>
                                    <div className="table-row-top">
                                        <div className="items">
                                            <div className="title">Client</div>
                                            <div className="value">{data?.client?.clientname}</div>
                                        </div>
                                        <div className="items">
                                            <div className="title">Fleet</div>
                                            <div className="value">{data?.fleet?.aircraft}</div>
                                        </div>
                                        <div className="items">
                                            <div className="title">Email</div>
                                            <div className="value">{data.email}</div>
                                        </div>
                                        <div>
                                            <Link to="/dashboard/data-admin">
                                                <button className="submit-button" onClick={() => {
                                                    if (Active1 === false) {
                                                        ActiveUserss({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUserssCrews({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUserssGroundss({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUsersssimulatorss({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUserssaircraft({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUserssmanagerss({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUserssdataAdminss({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        ActiveUserssoptimiser({
                                                            variables: {
                                                                userid: data?.userid || data?.managersid || data?.crewid,
                                                                active: Active1,
                                                            }
                                                        })
                                                        setTimeout(() => {
                                                            async function setDocument(db) {
                                                                const datas = {
                                                                    _aircraft: Active1,
                                                                    _crew: Active1,
                                                                    _ground: Active1,
                                                                    _manager: Active1,
                                                                    _simulator: Active1,
                                                                    _optimiser: Active1,
                                                                    _dataadmin: Active1,
                                                                    active: Active1,
                                                                    clientid: dropdown2[1],
                                                                    clientname: dropdown2[0],
                                                                    email: data.email
                                                                };
                                                                const res = await firebase.firestore().collection('users').doc(data?.managersid || data?.crewid || data?.userid).set(datas);
                                                                console.log(res);
                                                            }
                                                            setDocument()
                                                        },2000);
                                                    } else if (Active1 === true) {
                                                        users_actives({
                                                            variables:{
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                dataAdmin: dataAdmin1,
                                                                crew: crew1,
                                                                aircraft: aircraft1,
                                                                Ground: ground1,
                                                                manager: managerr1,
                                                                optimiser: optimiser1,
                                                                Simulator: simulator1,
                                                                active: Active1
                                                            }
                                                        })
                                                        userregister({
                                                            variables:{
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                dataAdmin: dataAdmin1,
                                                                crew: crew1,
                                                                aircraft: aircraft1,
                                                                Ground: ground1,
                                                                manager: managerr1,
                                                                optimiser: optimiser1,
                                                                Simulator: simulator1,
                                                            }
                                                        })
                                                        dataAdmin_actives({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                dataAdmin: dataAdmin1,
                                                            }
                                                        })
                                                        crew_actives({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                crew: crew1,
                                                            }
                                                        })
                                                        aircraft_actives({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                aircraft: aircraft1,
                                                            }
                                                        })
                                                        ground_activs({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                Ground: ground1,
                                                            }
                                                        })
                                                        manager_actives({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                manager: managerr1,
                                                            }
                                                        })
                                                        optimiser_actives({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                optimiser: optimiser1,
                                                            }
                                                        })
                                                        simulator_actives({
                                                            variables: {
                                                                usersid: data?.userid || data?.crewid || data?.managersid,
                                                                Simulator: simulator1
                                                            }
                                                        })
                                                        setTimeout(() => {
                                                            async function setDocument(db) {
                                                                const datas = {
                                                                    _aircraft: aircraft1,
                                                                    _crew: crew1,
                                                                    _ground: ground1,
                                                                    _manager: managerr1,
                                                                    _simulator: simulator1,
                                                                    _optimiser: optimiser1,
                                                                    _dataadmin: dataAdmin1,
                                                                    active: Active1,
                                                                    clientid: dropdown2[1],
                                                                    clientname: dropdown2[0],
                                                                    email: data.email
                                                                };
                                                                const res = await firebase.firestore().collection('users').doc(data?.managersid || data?.crewid || data?.userid).set(datas);
                                                                console.log(res);
                                                            }
                                                            setDocument()
                                                        }, 2000);
                                                    }
                                                }
                                                }>Update</button>
                                            </Link>
                                        </div>
                                    </div>
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', margin: '6px 3px' }}>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'active')}>Active</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'Crew')}>Crew</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'Ground')}>Ground</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'Simulator')}>Simulator</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'Aircraft')}>Aircraft</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'Manager')}>Manager</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'Optimiser')}>Optimiser</Checkbox>
                                        <Checkbox onChange={(e) => onChangeHandler(e, 'DataAdmin')}>DataAdmin</Checkbox>
                                    </div>
                                    <hr />
                                </div>
                            );
                        }
                    })) : null}
                </div>
            </div>
        </div>
    )
}

export default EditUser
